import React, {Component} from "react";
import {Form, Input , Radio,Row,Col,Checkbox,InputNumber,Upload,message,Spin,Icon,Modal } from 'antd';
import NHFormItem from '../../common/NHFormItem';
import NHFetch from "../../../utils/NHFetch";
import NHSelect from "../../common/NHSelect";
import {createUuid} from "../../../utils/NHCore";
const Dragger = Upload.Dragger;
const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;

/**
 * 绿色通道编辑表单
 * @author admin
 * @date 2018-03-16 11:28:34
 * Version: 1.0
 */
class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            previewImage:'',
            previewVisible: false,
            fileList: [],
            uploading:false,
            checkedOptions:[],
            defaultChecked:[],
            judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'],   //可以导入的图片格式
            judgeFileList: ['.pdf', '.PDF', '.doc', '.DOC', '.zip', '.ZIP', '.txt', '.TXT', '.xls', '.XLS', '.rar', '.RAR'],  //可以导入的非图片格式
            dkfsList: [], //贷款类型
            dkfsValue:""
        }
    }

    componentWillMount(){
        NHFetch('/proData/selectDataList','get','sign=dmk_YXXT_LSTD_BLYY').then(res=>{
            if(res){
                let data = res.data;
                let checkedOptions = data.map(item=>{return {label:item.LABEL,value:item.VALUE}});
                this.setState({checkedOptions:checkedOptions});
            }
        });
        let initFormData = this.props.initFormData;
        if(initFormData.PKID){//查询办理原因列表
            NHFetch(`/swbl/lstd/lstdblyy/${initFormData.PKID}/getBlyyList`,'get').then(res=>{
                if(res){
                    this.setState({defaultChecked:res.data});
                }
            });


        }
    }

    componentDidMount(){
        let initFormData = this.props.initFormData;
        if(initFormData.PKID) {
            this.loadfileList(initFormData.PKID);
        }
        this.loadLstddkfs();
        this.setState({
            dkfsValue:initFormData.DKLX
        })
    }

    loadLstddkfs=()=>{  
        NHFetch('front/zhxg-unauth/yxwz/proData/selectDataList','get','sign=DMK_YXXT_DKLX').then(res=>{  
            if(res && res.code == 200){  
               let dkfsList = res.data;  
                this.setState({  
                    dkfsList:dkfsList  
                })  
            }  
        });  
    } 

    loadfileList=(pkid)=>{
        NHFetch(`/swbl/lstd/${pkid}/getFjList`,'get').then(res=>{
            if(res){
                let fileList = [];
                if(res.data && res.data.length>0){
                    res.data.map((elem,index)=>{
                        //格式化对于附件取值
                        let file = {
                            uid: elem.fjid,
                            name: elem.fjmc,
                            response:{
                                data:{
                                    ssbh:elem.fjid,
                                    fjmc:elem.fjmc,
                                }
                            },
                            status: 'done'
                        }
                        fileList.push(file);
                    })
                }
                this.setState({fileList:fileList});
                this.props.form.setFieldsValue({fj:{fileList:this.state.fileList}});
            }
        });
    }


    beforeUpload = (file) => {
        if (
            !(this.setJudge(file.name, this.state.judgeImgList) ||
                this.setJudge(file.name, this.state.judgeFileList))
        ) {
            message.error('不能上传该格式文件');
            return false;
        } else {
            return true;
        }
    }

    // 关闭图片弹窗
    handleCancel = () => this.setState({ previewVisible: false });

    remove=(ssbh)=>{
        let url = `api/docrepo/attachment/sourceId/delete?souerceId=${ssbh}`;
        NHFetch(url,"POST").then(res => {
            if (res.data && res.data > 0) {
                message.success('已删除材料.');
            }
        });
    }

    handleChange = ({ fileList } ) => {
        let count = 0;
        fileList.map((elem)=>{
            if(elem && elem['status'] && elem['status']==='uploading'){
                this.setState({uploading:true});
                return;
            }else if(elem && elem['status']){
                count++;
            }
        })
        if(count>0){
            this.setState({uploading:false});
        }
    }

    //判断文件类型是否正常  name：文件名称  map：类型范围数组  true正常
    setJudge = (name, map) => {
        let flag = false;
        map.map(item => {
            if (name.indexOf(item) !== -1) {
                flag = true;
            }
        })
        return flag;
    }

    // 转化base64
    getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    };

    // 下载文件
    handlePreview = (file) => {
     //   window.open(`/api/docrepo/download/file?attachmentId=${fjid}`);
    };
    // 回调
    dkfsOnChange = e => {
        console.log('radio checked', e.target.value);
        this.setState({
            dkfsValue: e.target.value,
        });
      };

    render() {
        const {form,initFormData} = this.props;
        const {dkfsList,dkfsValue} = this.state;
        let formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
        };
        const props = {
            name: 'file',
            action: 'api/docrepo/upload',
            data: { uuid: createUuid(), type: '1' },
            onRemove: file => {
                this.setState(({ fileList }) => {
                    const index = fileList.indexOf(file);
                    const newFileList = fileList.slice();
                    newFileList.splice(index, 1);
                    return {
                        fileList: newFileList
                    };
                },()=>{
                    if(file.response && file.response.data && file.response.data.ssbh){
                        this.remove(file.response.data.ssbh);
                    }
                });
            },
            beforeUpload: file => {
                if(!this.beforeUpload(file)){
                    return false;
                }
                this.setState(({ fileList }) => ({
                    fileList: [...fileList, file]
                }));
                return true;
            },
            onChange:file=>{this.handleChange(file)},
            onPreview: this.handlePreview,
            fileList:this.state.fileList,
        };
        const checkedOptions = this.state.checkedOptions;
        return (
            <div>
                <div style={{display:'none'}}>
                    <NHFormItem id={"pkid"}
                        form={this.props.form}
                        initialValue={initFormData.PKID}>
                        <Input />
                    </NHFormItem>
                    <NHFormItem id={"xsid"} required={true} 
                        form={this.props.form}
                        initialValue={initFormData.XSID}>
                        <Input />
                    </NHFormItem>
                    <NHFormItem id={"nd"} required={true} 
                        form={this.props.form}
                        initialValue={initFormData.ND}>
                        <Input />
                    </NHFormItem>
                </div>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>
                        {initFormData.PKID?'':<span style={{marginRight:'4px',fontFamily:'SimSun',fontSize:'14px',color:'#f5222d'}}>*</span>}
                        姓名(学号)：
                    </Col>
                    <Col span={8}>{initFormData.XH?`${initFormData.XM}(${initFormData.XH})`:''}</Col>
                    <Col span={4} style={{textAlign:'right'}}>性别：</Col>
                    <Col span={8}>{initFormData.XB}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>学院：</Col>
                    <Col span={8}>{initFormData.BMMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>专业：</Col>
                    <Col span={8}>{initFormData.ZYMC}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>班级：</Col>
                    <Col span={8}>{initFormData.BJMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>年度：</Col>
                    <Col span={8}>{initFormData.ND}</Col>
                </Row>
                <NHFormItem id={"blyy"} required={true} label={"办理原因"}
                    form={this.props.form} formItemLayout={formItemLayout} 
                    initialValue={this.state.defaultChecked}>
                    <CheckboxGroup options={checkedOptions} />
                </NHFormItem>
                <NHFormItem id={"dklx"} required={true} label={"贷款方式"}
                    form={this.props.form} formItemLayout={formItemLayout} 
                    initialValue={initFormData.DKLX}
                    >
                    <Radio.Group onChange={this.dkfsOnChange} value={this.state.dkfsValue} style={{display:"flex",margin:"10px"}}>  
                        {  
                            dkfsList.map((item,index)=>{  
                                console.log(item);  
                                return  <Radio value={item.VALUE}>{item.LABEL}</Radio>  
                            })  
                        }  
                    </Radio.Group> 
                </NHFormItem>
                {dkfsValue=='1'&&<NHFormItem id={"blje"} required={true} label={"贷款金额"}
                    form={this.props.form} formItemLayout={formItemLayout} 
                    initialValue={initFormData.BLJE}>
                    <InputNumber style={{width:'300px'}} max={9999999}
                        formatter={value=>value?`￥${value}`:''} parser={value=>value.replace('￥','')}/>
                </NHFormItem>}
                {dkfsValue=='1'&&<NHFormItem id={"dkyh"} required={true} label={"请选择贷款银行"}
                            initialValue={initFormData.DKYH}
                            form={this.props.form} formItemLayout={formItemLayout}>
                    <NHSelect sign={"dmk_yxwz_dkyh"} style={{width:'300px'}}/>
                </NHFormItem>}
                {dkfsValue=='1'&&<NHFormItem id={"hzjym"} label={"6位数回执校验码"}
                            initialValue={initFormData.HZJYM} formItemLayout={formItemLayout}
                            required={true}
                            form={this.props.form}>
                    <Input style={{width:'300px'}} maxLength ={6}/>
                </NHFormItem>}
                <NHFormItem id={"sqsm"} required={false} label={"申请说明"} required={true}
                            initialValue={initFormData.SQSM}
                            form={this.props.form} formItemLayout={formItemLayout}>
                    <TextArea maxLength ={80} placeholder="请填写申请理由" style={{width:'600px'}}/>
                </NHFormItem>
                
                {/* <NHFormItem id={"fj"} label={'上传证明材料'}  hasFeedback={true} form={form}
                            formItemLayout={{labelCol: { span: 4 },wrapperCol: { span: 8 }}}>
                        <Dragger {...props}>
                            <p className="ant-upload-drag-icon">
                                <Icon type="inbox" />
                            </p>
                            <Spin spinning={this.state.uploading}/>
                            <p className="ant-upload-text font-14">
                                点击此处或拖拽文件到此
                            </p>
                        </Dragger>
                </NHFormItem>
                <Modal
                    visible={this.state.previewVisible}
                    footer={null}
                    onCancel={this.handleCancel}
                >
                    <img
                        alt="example"
                        style={{ width: '100%' }}
                        src={this.state.previewImage}
                    />
                </Modal> */}
            </div>
        );
    }
}

const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/swbl/szjdLstd/EditForm.js